import jsonpath from "../../__snowpack__/pkg/jsonpath.js";
import tailwindConfig from "../tailwind/tailwind.config.js";
const ROOT_FONT_SIZE = 16;
const {
  theme: tailwindTheme
} = tailwindConfig;
const {
  fontSize,
  inputSize
} = tailwindTheme;
function remStringToPixel(rem) {
  const cleanResult = rem.replace("rem", "").replace("em", "");
  if (!Number(cleanResult)) {
    return parseFloat(cleanResult).toString();
  }
  return remToPixel(parseFloat(cleanResult)).toString();
}
export function parseSize(size = "base", toPixel = false) {
  let result = fontSize.base[0].toString();
  if (typeof size === "string" && size in fontSize) {
    result = fontSize[size][0].toString();
  } else if (Number(size) > 0) {
    result = `${size.toString()}px`;
  }
  if (toPixel) {
    result = remStringToPixel(result);
  }
  return result;
}
export function parseInputSize(size, toPixel = false) {
  let result = inputSize.base.toString();
  if (size in inputSize) {
    result = inputSize[size].toString();
  }
  if (toPixel) {
    result = remStringToPixel(result);
  }
  return result;
}
export function getLineHeight(size = "base") {
  let result = "1.5rem";
  if (size in fontSize) {
    const fontSizeElement = fontSize[size][1];
    result = fontSizeElement.lineHeight;
  }
  return result;
}
export function remToPixel(rems, rootFontSize = ROOT_FONT_SIZE) {
  return rems * rootFontSize;
}
export function pixelToRem(pixels, rootFontSize = ROOT_FONT_SIZE) {
  return Math.floor(pixels / rootFontSize * 100) / 100;
}
function getCleanSizes() {
  return Object.entries(fontSize).filter(([, x], i, arr) => arr.findIndex(([, s]) => s[0] === x[0]) === i).reduce((a, [key, value]) => ({
    ...a,
    [key]: value
  }), {});
}
export function transformSize(size, transformation) {
  let result = "sm";
  if (size in fontSize) {
    const cleanSizes = getCleanSizes();
    const baseSizeList = Object.entries(cleanSizes);
    const sizeList = Object.keys(cleanSizes);
    const sizeEm = fontSize[size][0];
    const actualIndex = baseSizeList.findIndex(([, v]) => v[0] === sizeEm);
    const newIndex = Math.min(Math.max(0, actualIndex + transformation), sizeList.length - 1);
    result = sizeList[newIndex];
  }
  return result;
}
export function cmpClassName(suffix) {
  return `leo-component-${suffix}`;
}
export function getRandom(length = 8, minLength = length) {
  const max = +"9".repeat(length);
  const min = +("1" + "0".repeat(Math.max(0, minLength - 1)));
  return getRandomInt(min === 1 ? 0 : min, max);
}
export function getRandomNum() {
  const int = window.crypto.getRandomValues(new Uint32Array(1))[0];
  return int / 2 ** 32;
}
export function getRandomInt(min, max) {
  const _min = Math.ceil(min);
  const _max = Math.floor(max + 1);
  return Math.floor(getRandomNum() * (_max - _min)) + _min;
}
export function getRandomString(length = 8) {
  const letters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const chars = letters + letters.toUpperCase() + numbers;
  return Array(length).fill(0).map(() => chars.charAt(Math.floor(getRandomNum() * chars.length))).join("");
}
export function execFn(fn, ...params) {
  if (typeof fn === "function") {
    return fn(...params);
  }
  return void 0;
}
export function getBold(name) {
  if (name === true) {
    return {
      fontWeight: "700"
    };
  }
  switch (name) {
    case "thin":
      return {
        fontWeight: "100"
      };
    case "light":
      return {
        fontWeight: "300"
      };
    case "medium":
      return {
        fontWeight: "500"
      };
    case "semi":
      return {
        fontWeight: "600"
      };
    case "extra":
      return {
        fontWeight: "800"
      };
    default:
      return {
        fontWeight: "400"
      };
  }
}
function validateRules(rules, value, input) {
  let error = "";
  for (let i = 0; i < rules.length && !error; i++) {
    const fn = rules[+i];
    const result = fn(value, input);
    if (typeof result === "string") {
      error = result;
    }
  }
  return error;
}
export function validateInputRules(rules, value = "", input) {
  return validateRules(rules, value.toString(), input);
}
export function validateCheckRules(rules, value = false, input) {
  return validateRules(rules, value, input);
}
export function validateRadioRules(rules, value = false, input) {
  return validateRules(rules, value, input);
}
export function stringify(item, space) {
  function replacer(key, value) {
    let result = value;
    if (value && typeof value === "object" && "$$typeof" in value) {
      result = `${key}_[React Component]`;
    }
    return result;
  }
  if (item === null || item === void 0) {
    return item;
  }
  return JSON.stringify(item, replacer, space);
}
export function convertCssVar(cssVar, theme) {
  const match = /^var\(--(.*)\)/i.exec(cssVar);
  let result;
  if (match && match.length > 1) {
    const xpath = match[1].replace(/__/g, ".");
    result = jsonpath.query(theme, `$.${xpath}`)[0];
  }
  return result;
}
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [0, 0, 0];
}
export function getTextColor(color, theme) {
  let hex = typeof color === "object" ? color.DEFAULT || "" : color;
  if (theme && hex.startsWith("var(--")) {
    hex = convertCssVar(hex, theme);
  }
  if (!hex) {
    return "#ffffff";
  }
  const rgb = hexToRgb(hex);
  const lrgb = rgb.map((c) => {
    c = c / 255;
    if (c <= 0.03928) {
      c = c / 12.92;
    } else {
      c = Math.pow((c + 0.055) / 1.055, 2.4);
    }
    return c;
  });
  const res = 0.2126 * lrgb[0] + 0.7152 * lrgb[1] + 0.0722 * lrgb[2];
  return res > 0.179 ? "#000000" : "#ffffff";
}
export function setReverseDotNotation(item, actual = {}) {
  const {
    name,
    value
  } = item;
  function parseDotNotation(isLast, startOfObj, key) {
    if (isLast) {
      if (startOfObj[key] !== void 0) {
        const v = Array.isArray(startOfObj[key]) ? startOfObj[key] : [startOfObj[key]];
        startOfObj[key] = [...v, value];
      } else {
        startOfObj[key] = value;
      }
    } else {
      startOfObj = startOfObj[key] = startOfObj[key] || {};
    }
    return startOfObj;
  }
  if (name) {
    const keys = name.split(".");
    let startOfObj = actual;
    keys.forEach((key, i, arr) => {
      const isLast = i + 1 === arr.length;
      startOfObj = parseDotNotation(isLast, startOfObj, key);
    });
  }
  return actual;
}
function getMimeType(src) {
  const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim;
  const extension = src.match(fileExtensionPattern);
  switch (extension && extension[0]) {
    case ".jpg":
    case ".jpeg":
      return "image/jpeg";
    case ".bmp":
      return "image/bmp";
    case ".gif":
      return "image/gif";
    case ".ico":
      return "image/vnd.microsoft.icon";
    case ".png":
      return "image/png";
    case ".svg":
      return "image/svg+xml";
    case ".tiff":
      return "image/tiff";
    default:
      return "image/*";
  }
}
export function getBase64Image(img) {
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx?.drawImage(img, 0, 0);
  return canvas.toDataURL(getMimeType(img.src));
}
export function range(start, end) {
  start = Math.max(1, start);
  return Array(Math.max(0, end - start + 1)).fill(0).map((_x, i) => start + i);
}
export function getFullName(user) {
  return [user?.first_name, user?.last_name].filter(Boolean).join(" ");
}
